import { createGetEndpoint } from '@sonar-software/sonar-http';
import { InitiativeStatusReference } from '@types';

export type GetInitiativeStatusesResponse = {
	initiativeStatuses: Array<InitiativeStatusReference>;
};

export const getInitiativeStatuses = createGetEndpoint<void, GetInitiativeStatusesResponse>(
	'/api/v2/initiatives/statuses'
);
